import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.6025 7.40039L9.5498 18.4521L3.39746 12.2998L5.28906 10.4092L9.5498 14.6699L18.7109 5.50879L20.6025 7.40039Z" })
});
export default SvgCheck;
